<template>
<div class='body-job detail'>
    <div class='container'>
        <div class='box-m m-01 container-fluid'>
            <div class='row'>
                <div class='col-md-4 col-md-offset-8'>
                    <div class='content'>
                        <button class='btn btn-o btn-circle btn-block' 
                            @click='toAnchor(".m-02")'>成长计划</button>
                        <br>
                        <button class='btn btn-o btn-circle btn-block'
                            @click='toAnchor(".m-03")'>应答福利</button>
                        <br>
                        <button class='btn btn-o btn-circle btn-block'
                            @click='toAnchor(".m-04")'>应答招聘</button>
                        <br>
                    </div>
                </div>
            </div>
        </div>
        <div class='box-m m-02 container-fluid'>
            <div class='row'>
                <div class='col-md-5'>
                    <div class='content'>
                        <div class='title'>成长计划</div>
                        <div class='split'></div>
                        <br><br><br>
                        <div class='text'>
                            <p>如果你享受游戏，</p>
                            <p>如果你热爱游戏事业，</p>
                            <p>如果你喜欢有挑战性但是富有乐趣的工作，</p>
                            <p>如果你希望加入严谨纪律但又朝气勇敢博创新的团队，</p>
                            <p>加入我们</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class='box-m m-03 container-fluid'>
            <div class='row'>
                <div class='col-md-4 col-md-offset-8'>
                    <div class='content'>
                        <div class='title'>应答福利</div>
                        <div class='split'></div>
                        <br><br>
                        <div class='text'>
                            <p>丰富贴心的福利助力了元素们健康工作，</p>
                            <p>快乐生活</p>
                        </div>
                        <br>
                        <div class='nav'>
                            <div>餐饮补贴</div>
                            <div>通勤补贴</div>
                            <div>带薪休假</div>
                            <div>生日祝福</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class='box-m m-04 container-fluid'>
            <div class='row'>
                <div class='col-md-5'>
                    <div class='content'>
                        <div class='title'>应答招聘</div>
                        <div class='split'></div>
                        <br><br>
                        <div class='text'>
                            <p>应答网络将为员工提供施展才华的广阔发展空间和与之相称的优厚待遇，我们诚挚盼望您的加盟</p>
                            <p>E-mail：116164@qq.com</p>
                            <p>联系人：招聘组</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class='box-jobs'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-12 title'>热招职位</div>
                <div class='col-md-6 list'>
                    <div class='jobs'>
                        <div v-for='(item, key) in list' v-if='key%2 == 0'>
                            <div class='name' data-toggle='collapse' :data-target='"#job"+key'>
                                <i class='fa fa-circle'></i>
                                {{item.name}}
                                <i class='fa fa-angle-down pull-right'></i>
                            </div>
                            <div class='describe collapse' :id='"job"+key'>
                                <br>
                                <p>工作内容</p>
                                <p v-for='a in item.missions'>{{a}}</p>
                                <p>职位要求</p>
                                <p v-for='a in item.conditions'>{{a}}</p>
                                <br>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='col-md-6 list'>
                    <div class='jobs'>
                        <div v-for='(item, key) in list' v-if='key%2 == 1'>
                            <div class='name' data-toggle='collapse' :data-target='"#job"+key'>
                                <i class='fa fa-circle'></i>
                                {{item.name}}
                                <i class='fa fa-angle-down pull-right'></i>
                            </div>
                            <div class='describe collapse' :id='"job"+key'>
                                <br>
                                <p>工作内容</p>
                                <p v-for='a in item.missions'>{{a}}</p>
                                <p>职位要求</p>
                                <p v-for='a in item.conditions'>{{a}}</p>
                                <br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>
<script type="text/javascript">
import ScrollReveal from 'scrollreveal'
import Request from '@/common/Request'
export default {
    data : function(){
        return {
            list : []
        }
    },
    created : function(){
        window.scrollTo(0, 0)
        //加载工作列表
        var url = Request.createApi('/public/jobs')
        Request.get(url, res => {
            this.list = res.list
            setTimeout(function(){
                $(function(){
                    //折叠监听
                    $('.describe.collapse').on('show.bs.collapse', function(){
                        $(this).prev('.name').children('.pull-right')
                            .removeClass('fa-angle-down')
                            .addClass('fa-angle-up')
                    }).on('hide.bs.collapse', function(){
                        $(this).prev('.name').children('.pull-right')
                            .removeClass('fa-angle-up')
                            .addClass('fa-angle-down')
                    })
                })
            }, 1000)
        })
    },
    mounted : function(){
        var sr = ScrollReveal({
            'origin' : 'bottom',
            'distance' : '200px',
            'duration' : 500,
            'delay' : 200
        });
        sr.reveal('.content')
        // //滚动监听
        // var doms = ['.m-01', '.m-02', '.m-03', '.m-04', '.box-jobs']
        // var oldY = false;
        // var oldUpY = false
        // window.onmousewheel = document.onmousewheel = function(e){
        //     e = e || window.event;  
        //     var scrollTop = $(document).scrollTop()
        //     if (e.wheelDelta) {           
        //         if (e.wheelDelta > 0) { 
        //             if(scrollTop === oldUpY){
        //                 return true
        //             }
        //             console.log('run this')
        //             oldUpY = scrollTop
        //             for(var k = doms.length; k > 0; k--){
        //                 var _k = k -1
        //                 var dom = doms[_k]
        //                 if(scrollTop > $(dom).offset().top){
        //                     $.smoothScroll({scrollTarget: dom, speed : 400})
        //                     break
        //                 }
        //             }
        //             return false
        //         }  
        //         if (e.wheelDelta < 0) {
        //             if(scrollTop === oldY){
        //                 return true
        //             }
        //             console.log('run this down')
        //             oldY = scrollTop
        //             for(var k in doms){
        //                 var dom = doms[k]
        //                 if(scrollTop < $(dom).offset().top){
        //                     $.smoothScroll({scrollTarget: dom, speed : 400})
        //                     break
        //                 }
        //             }
        //             return false
        //         }  
        //     }
        // }
    },
    methods : {
        //跳转锚点
        toAnchor : function(dom){
            $.smoothScroll({scrollTarget: dom, speed : 400})
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/job/Detail.vue